import { AutogenModelPackagingType, AutogenRowPackagingType } from "./autogen/AutogenModelPackagingType";

export class ModelPackagingType extends AutogenModelPackagingType<RowPackagingType> {
    constructor() {
        super(RowPackagingType);
    }
}

export class RowPackagingType extends AutogenRowPackagingType {
}